<script>
import { ref } from "vue";

export default {
  name: "Memory",
  setup() {
    const componentKey = ref(0);

    const forceRerender = () => {
      componentKey.value += 1;
    };
    return {
      componentKey,
      forceRerender,
    };
  },
};
</script>

<template>
  <div :key="componentKey" @refresh="forceRerender"></div>
</template>
